const getFilenameFormPath = (path, separator = '/') => {
  if (!path) return '';
  const [file] = path.split(separator).reverse();
  return file;
};

export default getFilenameFormPath;
